import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import { HttpCacheService } from './http-cache.service';

/**
 * Caches HTTP requests.
 * Use ExtendedHttpClient fluent API to configure caching for each request.
 */
@Injectable({
  providedIn: 'root'
})
export class CacheInterceptor implements HttpInterceptor {
  private forceUpdate = false;
  private expiresIn?: number;

  constructor(private httpCacheService: HttpCacheService) {
    // httpCacheService.setPersistence('session');
  }

  /**
   * Configures interceptor options
   * @param options Cache interceptor instance's options.
   * @param options.forceUpdate Forces the request to be made.
   * @param options.expiresIn Cache expiration in seconds.
   * @return The configured instance.
   */
  configure(options?: { forceUpdate?: boolean; expiresIn?: number } | null): CacheInterceptor {
    const instance = new CacheInterceptor(this.httpCacheService);
    if (options) {
      instance.forceUpdate = !!options.forceUpdate;
      instance.expiresIn = options.expiresIn || null;
    }
    return instance;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.method !== 'GET') {
      return next.handle(request);
    }

    return new Observable<HttpEvent<any>>(subscriber => {
      const cachedData = this.forceUpdate ? null : this.httpCacheService.getCacheData(request.urlWithParams);
      if (cachedData !== null) {
        // Create new response to avoid side-effects
        subscriber.next(new HttpResponse(cachedData as object));
        subscriber.complete();
      } else {
        next.handle(request).subscribe({
          next: event => {
            if (event instanceof HttpResponse) {
              this.httpCacheService.setCacheData(request.urlWithParams, event, this.expiresIn);
            }
            subscriber.next(event);
          },
          error: error => subscriber.error(error),
          complete: () => subscriber.complete()
        });
      }
    });
  }
}
